import {
  ArrowRightStartOnRectangleIcon,
  CpuChipIcon,
  CommandLineIcon,
  ArrowsPointingOutIcon,
} from '@heroicons/react/24/outline';
import { NodeType } from '../../types/definition';

interface NodeToolbarProps {
  onDragStart?: (event: React.DragEvent, nodeType: NodeType) => void;
}

interface ToolbarItem {
  type: NodeType;
  label: string;
  icon: React.ComponentType<{ className?: string }>;
  color: string;
  bgColor: string;
  borderColor: string;
}

const toolbarItems: ToolbarItem[] = [
  {
    type: 'entry',
    label: 'Entry',
    icon: ArrowRightStartOnRectangleIcon,
    color: 'text-green-600 dark:text-green-400',
    bgColor: 'bg-green-100 dark:bg-green-900',
    borderColor: 'border-green-400 dark:border-green-600',
  },
  {
    type: 'agent',
    label: 'Agent',
    icon: CpuChipIcon,
    color: 'text-blue-600 dark:text-blue-400',
    bgColor: 'bg-blue-100 dark:bg-blue-900',
    borderColor: 'border-blue-400 dark:border-blue-600',
  },
  {
    type: 'function',
    label: 'Function',
    icon: CommandLineIcon,
    color: 'text-purple-600 dark:text-purple-400',
    bgColor: 'bg-purple-100 dark:bg-purple-900',
    borderColor: 'border-purple-400 dark:border-purple-600',
  },
  {
    type: 'branch',
    label: 'Branch',
    icon: ArrowsPointingOutIcon,
    color: 'text-orange-600 dark:text-orange-400',
    bgColor: 'bg-orange-100 dark:bg-orange-900',
    borderColor: 'border-orange-400 dark:border-orange-600',
  },
];

export function NodeToolbar({ onDragStart }: NodeToolbarProps) {
  const handleDragStart = (event: React.DragEvent, nodeType: NodeType) => {
    event.dataTransfer.setData('application/reactflow', nodeType);
    event.dataTransfer.effectAllowed = 'move';
    onDragStart?.(event, nodeType);
  };

  return (
    <div className="flex flex-wrap gap-2 p-3 bg-gray-50 dark:bg-gray-900 border-b border-gray-200 dark:border-gray-700">
      <span className="text-xs text-gray-500 dark:text-gray-400 self-center mr-2">
        Drag to add:
      </span>
      {toolbarItems.map((item) => {
        const Icon = item.icon;
        return (
          <div
            key={item.type}
            draggable
            onDragStart={(e) => handleDragStart(e, item.type)}
            className={`
              flex items-center gap-1.5 px-2.5 py-1.5 rounded-md border cursor-grab
              bg-white dark:bg-gray-800 ${item.borderColor}
              hover:shadow-md transition-shadow
              active:cursor-grabbing
            `}
          >
            <div className={`p-1 rounded ${item.bgColor}`}>
              <Icon className={`w-3.5 h-3.5 ${item.color}`} />
            </div>
            <span className="text-xs font-medium text-gray-700 dark:text-gray-300">
              {item.label}
            </span>
          </div>
        );
      })}
    </div>
  );
}
